
export default function MobileRow(row: FactorProductRow) {
  return (
    <div className="flex flex-col">
      <div className="flex">{row?.product?.title || "یک محصول انتخاب کنید"}</div>
      <div className="flex items-center gap-4 flex-wrap text-xs">
        {row.quantity !== undefined && row.unit !== undefined && (
          <div className="flex flex-col items-center">
            <span>تعداد</span>
            <span>
              {row.quantity} {row.unit}
            </span>
          </div>
        )}
        {row.price !== undefined && (
          <div className="flex flex-col items-center">
            <span>مبلغ واحد</span>
            <span>{row.price}</span>
          </div>
        )}
        {row.discountInput?.val !== undefined && (
          <div className="flex flex-col items-center">
            <span>تخفیف</span>
            <div className="flex items-center">
              <span>{row.discountInput?.val}</span>
              <span>{row.discountInput?.cond?.label}</span>
            </div>
          </div>
        )}
        {row.taxInput?.val !== undefined && (
          <div className="flex flex-col items-center">
            <span>مالیات</span>
            <div className="flex items-center">
              <span>{row.taxInput?.val}</span>
              <span>{row.taxInput?.cond?.label}</span>
            </div>
          </div>
        )}
        {row.totalPrice !== undefined && (
          <div className="flex flex-col items-center">
            <span>مبلغ کل</span>
            <span>{row.totalPrice}</span>
          </div>
        )}
      </div>
    </div>
  );
}
